<svg
  id="{{ name }}"
  xmlns="http://www.w3.org/2000/svg"
  [attr.width]="size"
  [attr.height]="size"
  viewBox="0 0 20 20"
  [attr.fill]="active ? '#FA8C16' : '#a1a2b2'"
>
  <path
    d="M19.2837 7.27462L13.3329 6.40977L10.6728 1.01681C10.6001 0.869149
              10.4806 0.749618 10.3329 0.676962C9.9626 0.494149 9.5126
              0.646493 9.32745 1.01681L6.66729 6.40977L0.716511
              7.27462C0.552449 7.29806 0.402449 7.3754 0.287605
              7.49259C0.148765 7.63529 0.0722582 7.82728 0.0748951
              8.02636C0.0775319 8.22544 0.159097 8.41533 0.301667
              8.55431L4.60714 12.752L3.58995 18.6793C3.5661 18.8172
              3.58135 18.959 3.63399 19.0886C3.68663 19.2183 3.77455
              19.3306 3.88777 19.4128C4.00099 19.4951 4.13498 19.5439 4.27456 19.5539C4.41413 19.5638
              4.55371 19.5345 4.67745 19.4692L10.0001 16.6707L15.3228 19.4692C15.4681 19.5465 15.6368
              19.5723 15.7985 19.5441C16.2064 19.4738 16.4806 19.0871 16.4103 18.6793L15.3931 12.752L19.6985
              8.55431C19.8157 8.43946 19.8931 8.28946 19.9165 8.1254C19.9798 7.71524 19.6939 7.33556 19.2837
              7.27462Z"
  />
</svg>
